var map = {
	"./404/404-error.png": "940c",
	"./Globe.png": "fe4e",
	"./about/bg1.png": "73a1",
	"./about/bg2.png": "2c32",
	"./about/head.png": "93cc",
	"./about/header-sm.png": "fbc4",
	"./about/header.png": "7d5d",
	"./about/honor/h1-1.png": "086c",
	"./about/honor/h1-2.png": "13d3",
	"./about/honor/h2-1.png": "920e",
	"./about/honor/h2-2.png": "e012",
	"./about/honor/h2-3.png": "603c",
	"./about/honor/h3-1.png": "f038",
	"./about/honor/h3-2.png": "e321",
	"./about/honor/h4-1.png": "11f8",
	"./about/honor/h4-2.png": "bda8",
	"./about/honor/honor-head.png": "63e3",
	"./about/logo1.png": "aefe",
	"./about/logo10.png": "4abb",
	"./about/logo11.png": "bab5",
	"./about/logo12.png": "adc8",
	"./about/logo13.png": "4c69",
	"./about/logo14.png": "576f",
	"./about/logo2.png": "7562",
	"./about/logo3.png": "7078",
	"./about/logo4.png": "b300",
	"./about/logo5.png": "cd8d",
	"./about/logo6.png": "b1f3",
	"./about/logo7.png": "ff29",
	"./about/logo8.png": "29c5",
	"./about/logo9.png": "f23c",
	"./about/news1.png": "c3d8",
	"./about/news2.png": "04da",
	"./about/service8.png": "abe4",
	"./about/team1.png": "4271",
	"./about/team2.png": "d67a",
	"./about/team3.png": "c5da",
	"./app/android-logo.png": "ddff",
	"./app/android.png": "3e62",
	"./app/app-logo.png": "1da5",
	"./app/bg-en.png": "5595",
	"./app/bg-phone.png": "aba8",
	"./app/bg.png": "b591",
	"./app/bg1.png": "3d1c",
	"./app/bg2.png": "9ba5",
	"./app/codeAPPXM.png": "c63e",
	"./app/funwork-logo.png": "bdef",
	"./app/head-bg.png": "d387",
	"./app/ios-logo.png": "dad6",
	"./app/ios.png": "ed3e",
	"./app/steps-title.png": "4ae7",
	"./app/steps1.en.png": "be76",
	"./app/steps1.png": "edff",
	"./app/steps2-1.en.png": "09d4",
	"./app/steps2-1.png": "a06d",
	"./app/steps2-2.en.png": "1122",
	"./app/steps2-2.png": "4934",
	"./app/steps3.en.png": "40b0",
	"./app/steps3.png": "5f8b",
	"./app/steps4.en.png": "2e4e",
	"./app/steps4.png": "4f3c",
	"./app/steps5.en.png": "efc1",
	"./app/steps5.png": "66f7",
	"./app/steps6-1.en.png": "3978",
	"./app/steps6-1.png": "8f02",
	"./app/steps6-2.en.png": "b7d0",
	"./app/steps6-2.png": "bfca",
	"./core/c1.png": "7ca0",
	"./core/c2.png": "afad",
	"./core/c3.png": "4abf",
	"./core/c4.png": "2827",
	"./core/c5.png": "6ef4",
	"./core/c6.png": "375e",
	"./core/core1.png": "a2c6",
	"./core/core2.png": "289d",
	"./core/core3.png": "8018",
	"./core/core4.png": "49b6",
	"./core/head.png": "578d",
	"./data/1-en.png": "71ab",
	"./data/1.png": "f5b3",
	"./data/2-en.png": "ba87",
	"./data/2.png": "fc88",
	"./data/3-en.png": "5251",
	"./data/3.png": "5f40",
	"./data/4-en.png": "199d",
	"./data/4.png": "2371",
	"./data/5-en.png": "843d",
	"./data/5.png": "a744",
	"./data/banner-example.png": "6326",
	"./data/header.png": "388e",
	"./data/icon/icn-image1.png": "bbd8",
	"./data/icon/icn-image2.png": "5e63",
	"./data/icon/icn-image3.png": "ebf9",
	"./data/icon/icn-image4.png": "85e6",
	"./data/icon/icn-image5.png": "a7ac",
	"./data/icon/icn-image6.png": "5018",
	"./data/icon/icn-text1.png": "d395",
	"./data/icon/icn-text2.png": "8842",
	"./data/icon/icn-video1.png": "21b5",
	"./data/icon/icn-video2.png": "a822",
	"./data/icon/icn-wav1.png": "bd29",
	"./data/icon/icn-wav2.png": "06cb",
	"./index/business1.png": "7b50",
	"./index/business2.png": "6da7",
	"./index/business3.png": "3702",
	"./index/business4.png": "28fd",
	"./index/f1.png": "c2be",
	"./index/f2.png": "ee53",
	"./index/f3.png": "af63",
	"./index/f4.png": "0c5a",
	"./index/globe.png": "b4dd",
	"./index/scenes/s1.png": "fb63",
	"./index/scenes/s2.png": "14a3",
	"./index/scenes/s3.png": "65ac",
	"./index/scenes/s4.png": "7c31",
	"./index/scenes/s5.png": "e9ed",
	"./index/scenes/s6.png": "e03d",
	"./index/scenes/s7.png": "a761",
	"./index/scenes/s8.png": "a875",
	"./index/scenes/s9-s.png": "d645",
	"./index/scenes/s9.png": "9004",
	"./index/solutions/head.png": "a95d",
	"./index/solutions/p1-s.png": "6a25",
	"./index/solutions/p1.png": "75a3",
	"./index/solutions/p2-s.png": "786b",
	"./index/solutions/p2.png": "5e5f",
	"./index/solutions/p3-s.png": "9424",
	"./index/solutions/p3.png": "30e9",
	"./index/solutions/s1.png": "0d6e",
	"./index/solutions/s2.png": "66e3",
	"./index/solutions/s3.png": "55c0",
	"./index/solutions/s4.png": "e814",
	"./index/solutions/s5.png": "6184",
	"./index/solutions/s6.png": "b54c",
	"./news/1.png": "60cf",
	"./news/2.png": "5ec9",
	"./news/logo.png": "cf02",
	"./partner/1.png": "ce23",
	"./partner/1s.png": "37bb",
	"./partner/2.png": "36d1",
	"./partner/2s.png": "9e75",
	"./partner/3.png": "f5e9",
	"./partner/3s.png": "b7e5",
	"./partner/join-phone.png": "0214",
	"./partner/join.png": "d28f",
	"./partner/logo1.png": "4100",
	"./partner/logo2.png": "f090",
	"./partner/logo3.png": "4906",
	"./partner/logo4.png": "d613",
	"./partner/logo5.png": "8e52",
	"./partner/logo6.png": "df7b",
	"./partner/logo7.png": "01b8",
	"./partner/logo8.png": "1416",
	"./partner/p1.png": "f053",
	"./partner/p2.png": "fc1f",
	"./partner/p3.png": "6688",
	"./partner/p4.png": "3795",
	"./partner/p5.png": "9b5a",
	"./partner/p6.png": "be91",
	"./platform/header-s.png": "dc16",
	"./platform/header.png": "e6d1",
	"./process/head-bg.png": "0dcc",
	"./service/1.png": "e4d3",
	"./service/2.png": "8c82",
	"./service/3.png": "7622",
	"./service/4.png": "39c2",
	"./service/5.png": "f084",
	"./service/client.png": "3d15",
	"./service/customize-bg.png": "9a37",
	"./service/process-xs.en.png": "2dca",
	"./service/process-xs.png": "179e",
	"./service/process.en.png": "cf3a",
	"./service/process.png": "40dd",
	"./service/tagging.png": "bbcb",
	"./t1.png": "5d8e",
	"./t2.png": "f2ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";